import ActionText from '../ActionText';
import { Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import { STATUS_DRAFT, STATUS_REJECTED } from '../utils/constants';

const DRAFT = STATUS_DRAFT;
const REJECTED = STATUS_REJECTED;

class StatusTimelineViewer extends React.Component {

    render() {

        const { classes, history } = this.props;

        return (
            <div>
                <Typography className={classes.mainHeading} style={{ marginTop: 10 }}>Status Changes Timeline</Typography>
                {history && history.length > 0 ?
                    <div>
                        <Table data-test="timeline-viewer" style={{ maxWidth: '100%' }}>
                            <TableHead>
                                <TableRow data-test="headers">
                                    {
                                        ["Date", "User", "Changed To"].map((col, index) =>
                                            <TableCell key={index} component="th" className={classes.tableHeading}>{col}</TableCell>
                                        )
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {history.map((item, rowIndex) => {
                                    const date = item.timeOfChange ? new Date(item.timeOfChange) : null;
                                    const dateText = date ? date.toLocaleString() : "";
                                    const row = [
                                        dateText,
                                        item.username || item.user,
                                        item.newValue === DRAFT ?
                                            "Draft"
                                            :
                                            item.newValue === REJECTED ?
                                                "Rejected"
                                                :
                                                "Approved"
                                    ];
                                    return (
                                        <TableRow
                                            data-test={"row-" + rowIndex}
                                            key={"row-" + rowIndex}
                                            classes={{
                                                root: classes.stripedRow
                                            }}>
                                            {row.map((cell, cellIndex) => {
                                                const spans = cell && typeof cell === "string" ? cell.split("\n") : [cell];
                                                return <TableCell
                                                    data-test={"cell-" + cellIndex}
                                                    key={cellIndex}
                                                    className={classes.tableCell}>
                                                    <Typography className={classes.tableCellText}>
                                                        {
                                                            spans.map((spanText, spanIndex) => <span className={classes.tableCellLine} key={spanIndex}>{spanText}</span>)
                                                        }
                                                    </Typography>
                                                </TableCell>;
                                            }
                                            )}
                                        </TableRow>
                                    );
                                }
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    :
                    <div style={{ marginBottom: 20 }}>
                        <ActionText offset="20px">No changes have been made.</ActionText>
                    </div>
                }
            </div>
        );
    }
}

StatusTimelineViewer.propTypes = {
    history: PropTypes.array.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(StatusTimelineViewer);